var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagDk({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 140 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26626_59419)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.13 0V36.22H64.32V0H139.13ZM44.04 0H0.5V36.22H44.04V0ZM0.5 56.2V92.42H44.04V56.2H0.5ZM64.32 92.42H139.13V56.2H64.32V92.42Z",
    fill: "#D01317"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.32 0H44.04V36.22H0.5V56.2H44.04V92.42H64.32V56.2H139.13V36.22H64.32V0Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26626_59419"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 138.63,
    height: 92.42,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagDk);
export default __webpack_public_path__ + "static/media/Flag_DK.6f61ffbb8e2edfd91c940ea0c28872e0.svg";
export { ForwardRef as ReactComponent };